
import Vue from "vue";
import { PageShowResource } from "@/modules/support/types";
import { pageShow, pageUpdate } from "@/modules/support/api";
import KTextField from "@/components/crud/fields/KTextField.vue";
import KForm from "@/components/KForm.vue";
import eventBus from "@/application/eventBus";
import { mapGetters } from "vuex";
import RichTextEditor from "@/components/crud/fields/RichTextEditor.vue";
import i18n from '@/plugins/i18n';
import { LanguageTypeEnum } from '@/modules/support/enums';

interface ComponentData {
  isLoading: boolean;
  isEditing: boolean;
  data?: PageShowResource;
  title: string;
  content: string;
}

export default Vue.extend({
  name: "InformationPageDetails",
  components: { RichTextEditor, KForm, KTextField },
  data: (): ComponentData => ({
    isLoading: false,
    isEditing: false,
    data: undefined,
    title: "",
    content: "",
  }),
  computed: {
    ...mapGetters({
      isAdmin: "authorisation/isAdmin",
    }),
  },
  mounted() {
    const pageSlug = this.$route.params.pageSlug as
      | string
      | undefined;
    this.fetchPage(pageSlug);
  },
  methods: {
    downloadUrl(url: string): string {
      if (/^(https?:)?\/\//.test(url)) return url;
      const path = url.replace(/^\/+/, "");
      return path.startsWith("files/") ? `/${path}` : `/files/${path}`;
    },
    async fetchPage(pageSlug?: string) {
      const locale = i18n.locale as keyof typeof LanguageTypeEnum;
      if (this.isLoading || !pageSlug || !(locale in LanguageTypeEnum)) return;
      this.isLoading = true;
      try {
        const response = await pageShow(pageSlug, LanguageTypeEnum[locale]);
        this.data = response.data.data;
        this.title = this.data.title || "";
        this.content = this.data.content || "";
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        throw error;
      }
    },
    handleSuccess() {
      eventBus.$emit("snackbar", this.$t("global.saveSuccess"));
      this.isEditing = false;
      this.fetchPage(this.data?.slug);
    },
    onHandleCancel() {
      this.isEditing = false;
      this.title = this.data?.title || "";
      this.content = this.data?.content || "";
    },
    request() {
      if (!this.data?.pageLanguageId) return;

      return pageUpdate({
        pageLanguageId: this.data.pageLanguageId,
        data: {
          title: this.title,
          content: this.content,
        },
      });
    },
  },
});
